import { c as _c } from "react/compiler-runtime";
/**
 * MaxWidth Component
 *
 * A container component that limits the maximum width of content
 * and centers it horizontally with responsive padding.
 *
 * @param {React.ReactNode} children - Content to be wrapped
 * @param {string} className - Additional CSS classes
 * @param {string} maxWidth - Maximum width preset (default: '7xl' = 1280px)
 *                            Options: 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl', 'full'
 * @param {string} padding - Horizontal padding classes (default: responsive padding)
 */
export default function MaxWidth(t0) {
  const $ = _c(4);
  const {
    children,
    className: t1,
    maxWidth: t2,
    padding: t3
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const maxWidth = t2 === undefined ? "7xl" : t2;
  const padding = t3 === undefined ? "px-0 sm:px-6 md:px-8 lg:px-20" : t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      sm: "max-w-sm",
      md: "max-w-md",
      lg: "max-w-lg",
      xl: "max-w-xl",
      "2xl": "max-w-2xl",
      "3xl": "max-w-3xl",
      "4xl": "max-w-4xl",
      "5xl": "max-w-5xl",
      "6xl": "max-w-6xl",
      "7xl": "max-w-7xl",
      full: "max-w-full"
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const maxWidthClasses = t4;
  const maxWidthClass = maxWidthClasses[maxWidth] || maxWidthClasses["7xl"];
  const t5 = `mx-auto w-full ${maxWidthClass} ${padding} ${className}`;
  let t6;
  if ($[1] !== children || $[2] !== t5) {
    t6 = <div className={t5}>{children}</div>;
    $[1] = children;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  return t6;
}